module.exports = __webpack_public_path__ + "static/media/cover6.19f2116d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover6.png
// module id = 559
// module chunks = 0